module.exports = __webpack_public_path__ + "media/images/menu-72c9e703717bb868c1d86727571078f8.png";